const GameType={
    OPEN_TYPE:0,// 开放平台
    START_LEVEL:1,//初赛
    FINAL_LEVEL:2,// 决赛
    MONTH_GAME:3,// 月赛
    ISRAEL_TYPE:4,//以色列比赛,
    COURSE_FRESS:5,//免费教材
    COURSE_COST:6,//付费教材
    MONTH_COST:7,// 付费月赛
    TEACH_COURSE:8,//考核教材
    WEEK_GAME_TYPE:9,// 周赛副本
};
export default GameType;


// WEBPACK FOOTER //
// ./src/data/GameType.js